const MODAL_CLOSE_TIMEOUT = 200

export { MODAL_CLOSE_TIMEOUT }
